const toggleScroll = () => {
  const scrollBarWidth = $(window).outerWidth() - $(window).innerWidth();

  $(window).scroll(() => false);

  const $body = $('body');
  $body.toggleClass('hidden');
  const $fixedElements = $('.fixed-element');

  if (window.matchMedia('(min-width: 992px)').matches) {
    if ($body.hasClass('hidden')) {
      $body.css({
        'padding-right': `${scrollBarWidth}px`,
        overflow: 'hidden',
      });
      $fixedElements.css({
        'right': `${scrollBarWidth}px`,
      });
    } else {
      // popup close after .3s, if remove settimout then will be jumping popup content
      setTimeout(() => {
        $body.css({
          width: 'auto',
          'padding-right': '0',
          overflow: 'visible',
        });
        $fixedElements.css({
          'right': 0,
        });
      }, 300);
    }
    return;
  }

  if ($body.hasClass('hidden')) {
    $body.css({
      overflow: 'hidden',
    });
  } else {
    setTimeout(() => {
      $body.css({
        overflow: 'visible',
      });
    }, 100);
  }
};


export default toggleScroll;
